import React from 'react';
import get from 'lodash/get';
import { withInject } from '@piwikpro/platform';
import {
  Stack,
  withTranslation,
  AutoSavedSelectControl,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

const SPLIT_AND_EXCLUDE = 'split_and_exclude';
const JUST_SPLIT = 'just_split';
const defaultValue = SPLIT_AND_EXCLUDE;

export interface ActionOnSessionLimitExceededProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class ActionOnSessionLimitExceeded
  extends React.Component<ActionOnSessionLimitExceededProps> {
  static readonly fieldName = 'session_limit_exceeded_action';

  constructor(props: ActionOnSessionLimitExceededProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        ActionOnSessionLimitExceeded.fieldName,
        settings.attributes[ActionOnSessionLimitExceeded.fieldName],
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <>
        <Stack vertical>
          {!failed && (
            <Stack.Item fill>
              <AutoSavedSelectControl
                id="app-settings-action-on-session-limit-exceeded"
                label={t('apps.details.settings.session-limits.action-on-session-limit-exceeded.title')}
                name={ActionOnSessionLimitExceeded.fieldName}
                initialValue={
                  get(settings.attributes, ActionOnSessionLimitExceeded.fieldName, defaultValue)
                }
                options={[{
                  id: 'global-settings-action-on-session-limit-exceeded-value',
                  items: [
                    {
                      id: SPLIT_AND_EXCLUDE,
                      value: SPLIT_AND_EXCLUDE,
                      name: t('apps.details.settings.session-limits.action-on-session-limit-exceeded.options.split-and-exclude'),
                    },
                    {
                      id: JUST_SPLIT,
                      value: JUST_SPLIT,
                      name: t('apps.details.settings.session-limits.action-on-session-limit-exceeded.options.just-split'),
                    },
                  ],
                }]}
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage />}
      </>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(ActionOnSessionLimitExceeded as any));
